import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import { JobHistoryStyle } from "./style";
import { driverVehicleTransferStatus, timezone, commonStrings } from "@utils/constant";
import { utcToShortMonthDate } from "@utils/commonFunctions";

function JobHistory(props) {
  const classes = JobHistoryStyle();
  const getColorByStatus = (status) => {
    switch (status) {
      case driverVehicleTransferStatus.accepted:
      case driverVehicleTransferStatus.allocated:
        return 'backgroundAccepted';
      case driverVehicleTransferStatus.rejected:
        return 'backgroundRejected';
      case driverVehicleTransferStatus.canceled:
      case driverVehicleTransferStatus.matchingPending:
      case driverVehicleTransferStatus.allocationPending:
        return 'backgroundPending';
      default:
        return 'backgroundRemoved';
    }
  };
  const formatDateToTimezone = (date) => {
    return date && utcToShortMonthDate(date, timezone.SYDNEY);
  }
  return (
    <div className={classes.jobHistory}>
      {props.historyHandoff.map((handoff, index) => {
        const actorDriver = handoff?.driverVehicleTransfers?.actorDrivers;
        const targetDriver = handoff?.driverVehicleTransfers?.targetDrivers;
        const event = handoff?.driverVehicleTransfers;
        const isRemoved = handoff?.jobHandoffStatus === commonStrings.void && handoff?.isRemoved;
        const listJobIds = event?.status === driverVehicleTransferStatus.rejected
          || event?.status === driverVehicleTransferStatus.canceled
          ? handoff?.driverVehicleTransfers?.handoffJobs.filter(handoffJob => !handoffJob.isRemoved).map(handoffJob => handoffJob.jobId) || []
          : handoff?.driverVehicleTransfers?.handoffJobs.filter(handoffJob => handoffJob.jobHandoffStatus !== commonStrings.void).map(handoffJob => handoffJob.jobId) || [];
        return (
          <Accordion square={true} key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="item-handoff">
                <div className="item-handoff-info">
                  <p className="item-handoff-title">
                    Handoff #{event?.id}: <span className="item-handoff-content">{actorDriver?.name ?? commonStrings.admin}</span> <TrendingFlatIcon /> <span className="item-handoff-content">{targetDriver?.name ?? commonStrings.jobPool}</span>
                  </p>
                  {isRemoved ? (
                    <span className="item-handoff-content">Removed from the Handoff: <b>{formatDateToTimezone(handoff?.updatedAt)}</b></span>
                  ) : (
                    <span className="item-handoff-content">Initiated: <b>{formatDateToTimezone(event?.createdAt)}</b> | Finalized: <b>{formatDateToTimezone(event?.updatedAt)}</b></span>
                  )}
                </div>
                <div className={`item-handoff-status ${getColorByStatus(isRemoved ? 'Removed' : event?.status)}`}>
                  <span className="status">{isRemoved ? 'Removed' : event?.status}</span>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              {isRemoved ? (
                <>
                  <div className="prompt-cancel-status">
                    <p><b>Void Entry:</b> This job was removed from the handoff. It may have been assigned or allocated as a local portion.</p>
                  </div>
                  <div className="item-handoff-details">
                    <div className="item-handoff-option">
                      <p className="item-handoff-details-title">ORIGINAL HANDOFF OPTION</p>
                      <p className="item-handoff-details-content">{event?.handoffType} Jobs</p>
                    </div>
                    <div className="item-handoff-vehicle-option">
                      <p className="item-handoff-details-title">ORIGINAL VEHICLE OPTION</p>
                      <p className="item-handoff-details-content">Transfer {event?.swapType}</p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="item-handoff-details">
                    <div className="item-handoff-option">
                      <p className="item-handoff-details-title">HANDOFF OPTION</p>
                      <p className="item-handoff-details-content">{event?.handoffType} Jobs</p>
                    </div>
                    <div className="item-handoff-vehicle-option">
                      <p className="item-handoff-details-title">VEHICLE OPTION</p>
                      <p className="item-handoff-details-content">Transfer {event?.swapType}</p>
                    </div>
                  </div>
                  <div className="item-handoff-manifest">
                    <p className="item-handoff-details-title">JOBS INCLUDED</p>
                    <p className="item-handoff-details-content">Jobs: {listJobIds.sort((a, b) => b - a).join(', ')}</p>
                  </div>
                </>
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}
export default JobHistory;